var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-result-container"},[(_vm.paySuccess)?_c('div',{staticClass:"success-message"},[_c('p',[_vm._v("支付成功！")])]):_vm._e(),(!_vm.paySuccess && !_vm.retryingPayment)?_c('div',{staticClass:"retry-container"},[_c('button',{staticClass:"retry-button",on:{"click":_vm.retryPayment}},[_vm._v("重新支付")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }